import { Warrior } from '~/../api/common.types';
import { getCurrentWarrior } from '~/utils/utils';

function DeadWarrior({
  deadWarrior,
  deadWarriorIds,
  setDeadWarriorIds,
  deadWarriorsNeeded,
}: {
  deadWarrior: Warrior;
  deadWarriorIds: Array<string>;
  setDeadWarriorIds: any;
  deadWarriorsNeeded: boolean;
}) {
  const warriorData = getCurrentWarrior(deadWarrior);
  const warriorId = deadWarrior.warrior_id.toString();
  const isSelected = deadWarriorIds.includes(warriorId);

  const handleClick = () => {
    if (deadWarriorIds.includes(warriorId)) {
      setDeadWarriorIds((deadWarriorIds) =>
        deadWarriorIds.filter((id) => id !== warriorId)
      );
    } else {
      setDeadWarriorIds([...deadWarriorIds, warriorId]);
    }
  };

  return (
    <button
      className={`grid__item ${isSelected ? 'is-selected' : ''}`}
      onClick={handleClick}
      disabled={!deadWarriorsNeeded}
    >
      <img src={warriorData.images.dead} alt={warriorData.name} />
      <h4>{warriorData.name}</h4>
      <p>
        Level {warriorData.level}, HP {warriorData.hp}, Type {warriorData.type},
        Syndicate {warriorData.syndicate}
      </p>
    </button>
  );
}

function DeadWarriors({
  deadWarriors,
  reviveId,
  deadWarriorIds,
  setDeadWarriorIds,
  deadWarriorsNeeded,
}: {
  reviveId: string | null;
  deadWarriors: Array<Warrior> | undefined;
  deadWarriorIds: Array<string> | [];
  setDeadWarriorIds: any;
  deadWarriorsNeeded: boolean;
}) {
  // filter out warrior that is being revived
  const filteredWarriors = deadWarriors?.filter(
    (warrior) => warrior.warrior_id.toString() !== reviveId?.toString()
  );
  return (
    <div className="grid-revive-warriors">
      {filteredWarriors?.map((warrior, i) => (
        <DeadWarrior
          deadWarrior={warrior}
          key={i}
          deadWarriorIds={deadWarriorIds}
          setDeadWarriorIds={setDeadWarriorIds}
          deadWarriorsNeeded={deadWarriorsNeeded}
        />
      ))}
    </div>
  );
}

export default DeadWarriors;
